export const config = {
    appId: 'b92f9379-9e28-4076-9ba1-5546b988b1b6',
    redirectUri: 'https://sspeiser.github.io/onenote-export', // 'http://localhost:3000',
    scopes: [
      'user.read',
      'notes.read',
    ]
  };